import { render } from "./bioform.vue?vue&type=template&id=f9ce193c&scoped=true"
import script from "./bioform.vue?vue&type=script&lang=js"
export * from "./bioform.vue?vue&type=script&lang=js"

import "./bioform.vue?vue&type=style&index=0&id=f9ce193c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-f9ce193c"

export default script